import { useQuery } from '@cqrs/vue-composables-cqrs';
import * as q from '@Organizations/Workspaces/Domain/queries-core';
import { isRef, ref, Ref } from 'vue';
export function useAuthUserWorkspacesEntriesQueryV1() {
	const result = {
		...useQuery(() => new q.AuthUserWorkspacesEntriesQueryV1())
	}
	return {
		...result,
		runAuthUserWorkspacesEntriesQueryV1: result.run,
		modelAuthUserWorkspacesEntriesQueryV1: result.model,
	};
}

export function useAuthUserWorkspacesQueryV1() {
	const result = {
		...useQuery(() => new q.AuthUserWorkspacesQueryV1())
	}
	return {
		...result,
		runAuthUserWorkspacesQueryV1: result.run,
		modelAuthUserWorkspacesQueryV1: result.model,
	};
}

export function useWorkspaceDetailsQueryV1(workspaceId?: string | Ref<string>, ) {
	const _workspaceId = isRef<string>(workspaceId) ? workspaceId : ref<string>(workspaceId)
	const result = {
		workspaceId: _workspaceId,
		...useQuery(() => new q.WorkspaceDetailsQueryV1(_workspaceId.value))
	}
	return {
		...result,
		runWorkspaceDetailsQueryV1: result.run,
		modelWorkspaceDetailsQueryV1: result.model,
	};
}

export function useWorkspaceInvitationQueryV1(token?: string | Ref<string>, ) {
	const _token = isRef<string>(token) ? token : ref<string>(token)
	const result = {
		token: _token,
		...useQuery(() => new q.WorkspaceInvitationQueryV1(_token.value))
	}
	return {
		...result,
		runWorkspaceInvitationQueryV1: result.run,
		modelWorkspaceInvitationQueryV1: result.model,
	};
}

export function useWorkspaceMembersQueryV1(workspaceId?: string | Ref<string>, ) {
	const _workspaceId = isRef<string>(workspaceId) ? workspaceId : ref<string>(workspaceId)
	const result = {
		workspaceId: _workspaceId,
		...useQuery(() => new q.WorkspaceMembersQueryV1(_workspaceId.value))
	}
	return {
		...result,
		runWorkspaceMembersQueryV1: result.run,
		modelWorkspaceMembersQueryV1: result.model,
	};
}

export function useWorkspacesByOrganizationQueryV1(tenantId?: number | Ref<number>, ) {
	const _tenantId = isRef<number>(tenantId) ? tenantId : ref<number>(tenantId)
	const result = {
		tenantId: _tenantId,
		...useQuery(() => new q.WorkspacesByOrganizationQueryV1(_tenantId.value))
	}
	return {
		...result,
		runWorkspacesByOrganizationQueryV1: result.run,
		modelWorkspacesByOrganizationQueryV1: result.model,
	};
}

export function useWorkspacesByUserQueryV1(userId?: string | Ref<string>, ) {
	const _userId = isRef<string>(userId) ? userId : ref<string>(userId)
	const result = {
		userId: _userId,
		...useQuery(() => new q.WorkspacesByUserQueryV1(_userId.value))
	}
	return {
		...result,
		runWorkspacesByUserQueryV1: result.run,
		modelWorkspacesByUserQueryV1: result.model,
	};
}

